import BaseModule from "~/vuex/modules/base-module";

let BookingCabins = {...BaseModule};

BookingCabins.state = function () {
    let state = BaseModule.state();


    //state.endpoints['all'] = '/api/...';

    state.lastDate = null;
    state.sort = {};


    return state;
};

BookingCabins.actions.changeCabin = async function({state, commit, getters}, data) {
    let endpoint = '/api/bookings/' + data.bookingId + '/cabins/' + data.bookedCabinId;
    let response = await this.axios.patch(
        endpoint,
        {
            data: {
                type: "booked_cabin",
                id: data.bookedCabinId,
                attributes: {
                    number: data.newCabinNumber,
                    plusgrade_fee: data.plusgrade_fee
                }

            },
            meta: {
                keep_charged_grade: data.keep_charged_grade,
                reason: data.reason,
                released_cabin_status: data.released_cabin_status,
                skip_availability_check: data.skip_availability_check
            }
        }
    );

}


export default BookingCabins;